import React, {} from 'react';

import { ReactComponent as LeftAlignmentButton } from 'assets/images/left-alignment-toggle-icon.svg';
import { ReactComponent as CenterAlignmentButton } from 'assets/images/center-alignment-toggle-icon.svg';
import { ReactComponent as RightAlignmentButton } from 'assets/images/right-alignment-toggle-icon.svg';

const alignmentTypes = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

function ImageAlignmentTool(props) {

  function renderRightButton() {

    const rightAlignmentButtonAttributes = {
      className: 'align-right-control',
      contentEditable: false,
      onClick() {
        props.onAlignmentChange(alignmentTypes.RIGHT, {
          marginLeft: 'auto',
          marginRight: null
        });
      }
    };

    if (props.alignment === alignmentTypes.RIGHT) {
      rightAlignmentButtonAttributes.className += ' active';
    }

    return <button {...rightAlignmentButtonAttributes}>
      <RightAlignmentButton />
    </button>;

  }

  function renderCenterButton() {

    const centerAlignmentButtonAttributes = {
      className: 'align-center-control',
      contentEditable: false,
      onClick() {
        props.onAlignmentChange(alignmentTypes.CENTER, {
          marginLeft: 'auto',
          marginRight: 'auto'
        });
      }
    };

    if (props.alignment === alignmentTypes.CENTER) {
      centerAlignmentButtonAttributes.className += ' active';
    }

    return <button {...centerAlignmentButtonAttributes}>
      <CenterAlignmentButton />
    </button>;

  }

  function renderLeftButton() {

    const leftAlignmentButtonAttributes = {
      className: 'align-left-control',
      contentEditable: false,
      onClick() {
        props.onAlignmentChange(alignmentTypes.LEFT, {
          marginLeft: null,
          marginRight: 'auto'
        });
      }
    };

    if (props.alignment === alignmentTypes.LEFT) {
      leftAlignmentButtonAttributes.className += ' active';
    }

    return <button {...leftAlignmentButtonAttributes}>
      <LeftAlignmentButton />
    </button>;

  }

  function renderMain() {

    const mainAttributes = {
      className: 'image-alignment-tool',
      style: {

      }
    };

    return <div {...mainAttributes}>
      {renderLeftButton()}
      {renderCenterButton()}
      {renderRightButton()}
    </div>;

  }

  return renderMain();

}

ImageAlignmentTool.determineAlignment = function determineAlignment(element) {

  const marginLeft = element.marginLeft;
  const marginRight = element.marginRight;

  if (marginLeft === void 0 && marginRight === void 0) {
    return 'center';
  }

  if (marginLeft === 'auto' && marginRight === 'auto') {
    return 'center';
  }

  if (marginLeft === 'auto') {
    return 'right';
  }

  return 'left';

};

export default ImageAlignmentTool;